import { saveEhpadSubscription } from "../../../components/EhpadSubscriptionFields";
import { API } from "../../../services/api";
import { DEFAULT_EHPAD_COLOR } from "../adminConstants";
import { INVALID_INVITATION_EMAIL, invitationFailureSentence, isValidInvitationEmail, sendEhpadInvitation, withContactEmail } from "./ehpadInvitations";

// Valeurs du formulaire d'édition, reprises de la fiche.
export function ehpadEditorForm(ehpad) {
    return {
        code: ehpad.code ?? "",
        nom: ehpad.nom ?? "",
        address: ehpad.address ?? "",
        phone: ehpad.phone ?? "",
        tourneeId: ehpad.tourneeId != null ? String(ehpad.tourneeId) : "",
        color: ehpad.color ?? DEFAULT_EHPAD_COLOR,
        controleMode: ehpad.controleMode ?? "",
        productionSubcategories: ehpad.productionSubcategories ?? [],
        productionSubcategoryDraft: "",
    };
}

// Validation du navigateur désactivée (messages en anglais) : les champs obligatoires sont vérifiés ici.
export function ehpadEditorValidationError(form, email, subscription) {
    if (!form.code.trim() || !form.nom.trim()) return "Le code et le nom de l'EHPAD sont obligatoires.";
    if (email && !isValidInvitationEmail(email)) return INVALID_INVITATION_EMAIL;
    if (subscription.error) return subscription.error;
    return null;
}

// Enregistre la fiche. Le PUT n'enregistre pas les emails : l'email de raccordement passe par la route dédiée.
export async function putEhpad(ehpad, form, email) {
    let { data } = await API.put(`/admin/ehpads/${ehpad.id}`, {
        code: form.code,
        nom: form.nom,
        address: form.address || null,
        phone: form.phone || null,
        emailsContact: ehpad.emailsContact ?? [],
        emailsFax: ehpad.emailsFax ?? [],
        tourneeId: form.tourneeId ? Number(form.tourneeId) : null,
        color: form.color,
        controleMode: form.controleMode || null,
        productionSubcategories: form.productionSubcategories,
    });
    const currentContactEmails = ehpad.emailsContact ?? [];
    const contactEmails = withContactEmail(currentContactEmails, email);
    if (contactEmails !== currentContactEmails) {
        ({ data } = await API.patch(`/admin/ehpads/${ehpad.id}/emails`, {
            emailsContact: contactEmails,
            emailsFax: ehpad.emailsFax ?? [],
        }));
    }
    return data;
}

// Abonnement et invitation sont indépendants : l'échec de l'un n'empêche pas l'autre. Le compte rendu dit
// précisément ce qui a réussi et ce qui a échoué.
export async function saveEhpadFollowUps({ ehpadId, email, subscription, onInvited, onInvitationSent }) {
    const report = ["EHPAD enregistré."];
    let failed = false;
    if (subscription.payload) {
        try {
            await saveEhpadSubscription(ehpadId, subscription.payload);
            report.push("Abonnement enregistré.");
        } catch (err) {
            failed = true;
            report.push(`L'abonnement n'a pas pu être enregistré : ${err.response?.data?.message ?? "erreur inconnue"}.`);
        }
    }
    if (email) {
        try {
            onInvited(await sendEhpadInvitation(email, ehpadId));
            // Déjà envoyée : un nouvel « Enregistrer » ne doit pas la renvoyer.
            onInvitationSent();
            report.push(`Invitation envoyée à ${email}.`);
        } catch (err) {
            failed = true;
            report.push(invitationFailureSentence(err));
        }
    }
    return { failed, report };
}
